/* eslint-disable */
import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  siteDocuments:null,
  kitsAccess: false,
  reportsAccess: false,
  allOrders: null,
  allKitsforSite: null,
  addresses: null,
  addresses2: null,
  countries: null,
  activeAddressId: null,
  orderDetail: null,
  storeItems: null,
  cartAdded: false,
};

export const orders = createSlice({
  name: 'orders',
  initialState,
  reducers: {
    setSiteDocuments: (state, action) => {
      state.siteDocuments = action.payload;
    },
    setHasKitsAccess: (state, action) => {
      state.kitsAccess = action.payload;
    },
    setHasReportsAccess: (state, action) => {
      state.reportsAccess = action.payload;
    },
    setAllOrders: (state, action) => {
      state.allOrders = action.payload;
    },
    setAllKitsforSite: (state, action) => {
      state.allKitsforSite = action.payload;
    },
    setStoreItems: (state, action) => {
      state.storeItems = action.payload;
    },
    setAllCountriesReducer: (state, action) => {
      state.countries = action.payload;
    },
    setActiveAddressId: (state, action) => {
      state.activeAddressId = action.payload;
    },
    setDeleteAddress: (state, action) => {
      state.addresses = state.addresses.filter(
        (add) => add.id !== action.payload
      );
    },
    setCartAdded: (state, action) => {
      state.cartAdded = action.payload;
    },
    setOrderDetail: (state, action) => {
      state.orderDetail = action.payload;
    },
    setAllAddresses2 : (state, action) => {
      state.addresses2 = action.payload;
    },
    setAllAddresses: (state, action) => {
      console.log(action);
      state.addresses = action.payload;
    },
    updateItemCount: (state, action) => {
      state.allKitsforSite = state.allKitsforSite?.map((kit) => {
        if (kit.id === action.payload?.data?.id) {
          return {
            ...kit,
            count:
              (kit?.count ? kit.count : 0) +
              (action.payload.count != null
                ? parseInt(action.payload?.count)
                : 0),
          };
        } else {
          return kit;
        }
      });
    },
    setItemCount: (state, action) => {
      console.log('amer2', action);
      state.allKitsforSite = state.allKitsforSite?.map((kit) => {
        if (kit.id === action.payload?.data?.id) {
          return { ...kit, count: action.payload?.count };
        } else {
          return kit;
        }
      });
    },
    setAddToCart: (state, action) => {
      console.log('amer1', action);
      state.allKitsforSite = state.allKitsforSite?.map((kit) => {
        if (kit.id === action.payload?.data?.id) {
          if (!action.payload.status) {
            return { ...kit, addtocart: action.payload.status, count: 0 };
          } else {
            return { ...kit, addtocart: action.payload.status };
          }
        } else {
          return kit;
        }
      });
    },
    resetCartItem: (state, action) => {
      console.log('amer', action);
      state.allKitsforSite = state.allKitsforSite?.map((kit) => {
        return { ...kit, addtocart: false };
      });
    },
  },
});

export const {
  setDeleteAddress,
  setActiveAddressId,
  setAllCountriesReducer,
  setAllOrders,
  setAllKitsforSite,
  setAddToCart,
  updateItemCount,
  setAllAddresses,
  setOrderDetail,
  resetCartItem,
  setStoreItems,
  setItemCount,
  setCartAdded,
  setAllAddresses2,
  setSiteDocuments,
  setHasKitsAccess,
  setHasReportsAccess,
} = orders.actions;

export default orders.reducer;
